import { render, staticRenderFns } from "./FloatingWindow.vue?vue&type=template&id=98eb9b0e&scoped=true"
import script from "./FloatingWindow.vue?vue&type=script&lang=js"
export * from "./FloatingWindow.vue?vue&type=script&lang=js"
import style0 from "./FloatingWindow.vue?vue&type=style&index=0&id=98eb9b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98eb9b0e",
  null
  
)

export default component.exports